export function SigWazLogo() {
  return (
    <span style={{ fontSize: 15, fontWeight: 700, letterSpacing: "-0.35px" }}>
      Sig<span style={{ color: "var(--accent)" }}>Waz</span>
    </span>
  );
}
